import { Icon, Stack, Typography } from "@mui/material";
import { SatisfactionItem } from "../../../constants/SatisfactionConstants";

export default function Satisfaction(props: {
    item: SatisfactionItem;
    selectedValue: number;
    onSelect: (v: number) => void;
}) {
    return (
        <Stack
            sx={{
                color: props.item.color,
                width: 75,
                borderRadius: "8px",
                bgcolor:
                    props.selectedValue === props.item.value
                        ? "#dddddd"
                        : "transparent",
                p: 1,
            }}
            alignItems="center"
            onClick={() => props.onSelect(props.item.value)}
            spacing={1}
        >
            <Icon sx={{ color: "inherit", fontSize: "50px" }}>
                {props.item.icon}
            </Icon>
            <Typography sx={{ color: "inherit", fontSize: "smaller" }}>
                {props.item.title}
            </Typography>
        </Stack>
    );
}
